import { createControlFn } from "../create-control-fn"

const controlCapFieldFn = createControlFn({
  filterValueCb: (value) => /^[0-9]{0,5}$/.test(value),
})

const controlForeignCapFieldFn = createControlFn({
  filterValueCb: (value) => /^[a-zA-Z0-9]{0,12}$/.test(value),
})

export { controlCapFieldFn, controlForeignCapFieldFn }
